<template>
  <b-row>
    <template v-if="$route.name === 'EXCMAgreementShow'">
      <b-col v-if="isLoading">
        <Loader size="lg"></Loader>
      </b-col>
      <b-col v-else>
        <EXCMCyclicTaskForm
          :handle-submit="onSendForm"
          :handle-update-field="updateField"
          :values="item"
          :errors="violations" />
      </b-col>
    </template>
    <template v-else>
      <b-col v-if="isLoading">
        <Loader size="lg"></Loader>
      </b-col>
      <b-col v-else>
        <!--<b-row>-->
        <!--<b-col>-->
        <!--<div v-if="isLoading" class="alert alert-info" role="status">{{$t('alerts.loading')}}...</div>-->
        <!--<div v-if="error" class="alert alert-danger" role="alert">-->
        <!--<span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ error }}-->
        <!--</div>-->
        <!--</b-col>-->
        <!--</b-row>-->
        <b-row>
          <b-col>
            <router-link :to="{ name: 'EXCMCyclicTaskList' }" class="btn btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-card>
              <div class="card-body">
                <b-row>
                  <b-col>
                    <EXCMCyclicTaskForm
                      :handle-submit="onSendForm"
                      :handle-update-field="updateField"
                      :values="item"
                      :errors="violations" />
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </template>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import EXCMCyclicTaskForm from './Form'
import Loader from '../../Layout/Loader'
import { checkPagePermission } from '@/utils/checkRoles'

const { mapGetters, mapActions } = createNamespacedHelpers('excmcyclictask/create')

export default {
  components: {
    EXCMCyclicTaskForm,
    Loader
  },
  props: {
    agreementIRI: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      routeName: '',
      item: {}
    }
  },

  computed: mapGetters([
    'error',
    'isLoading',
    'created',
    'violations'
  ]),

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }
      if (this.routeName === 'EXCMAgreementShow') {
        this.$store.state.modals.excmcyclictask.create.created = 1
        this.$store.state.modals.excmcyclictask.create.close = 1
      } else {
        this.$router.push({ name: 'EXCMCyclicTaskUpdate', params: { id: created['@id'] } })
      }
    }
  },
  beforeCreate () {
    checkPagePermission('tasks', 'EXCMCyclicTaskCreate')
  },

  created () {
    this.routeName = this.$route.name
    if (this.agreementIRI) {
      this.item.agreement = this.agreementIRI
    }
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm () {
      this.item.daysInterval = parseInt(this.item.daysInterval)
      if (this.item.dateFrom) {
        this.item.dateFrom = this.$moment(this.item.dateFrom).format('YYYY-MM-DD')
      }
      if (this.item.dateTo) {
        this.item.dateTo = this.$moment(this.item.dateTo).format('YYYY-MM-DD')
      }
      this.create(this.item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
